module.exports = __webpack_public_path__ + "img/sf.98927a05.png";